<template>
  <div class="configurations-legal-mentions">
    <b-container fluid>
      <b-container>
        <appLegalMentions></appLegalMentions>
      </b-container>
      <router-view />
    </b-container>
  </div>
</template>

<script>
import appConfigurationsNav from "@/components/snippets/ConfigurationsNav";

export default {
  components: {
    appConfigurationsNav,
    appLegalMentions: () => import("@/components/configurations/legal-mentions/LegalMentions.vue"),
  },
};
</script>
